import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.333 1.333h-8A.667.667 0 0 0 2.667 2v10.667a.667.667 0 0 0 .666.666H4V14a.667.667 0 1 0 1.333 0v-.667h6a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2ZM9.333 12H4V2.667h5.333V12ZM12 11.333a.667.667 0 0 1-.667.667h-.666V2.667h.666a.667.667 0 0 1 .667.666v8Z" }, null, -1)
  ])))
}
export default { render: render }